<template>

    <div>

        <v-flex xs12 sm10 offset-sm1 md8 offset-md2 lg6 offset-lg3>
            <!-- Alert -->
            <Alert v-if="alertType !== ''" :atype="alertType" :message="alertMessage" :visibility="visibility" />

            <v-progress-linear v-if="progressbar" :indeterminate="true"></v-progress-linear>

            <!--Lists-->
            <v-list two-line class="semi-transparent-bg">

                <v-subheader>

                    {{ $t( 'withdraw.bank_detail' ) }}

                    <v-spacer></v-spacer>

                    <v-btn icon dark mt-5 color="grey" :to="{ name: 'Addbank'}">
                        <v-icon>add</v-icon>
                    </v-btn>

                </v-subheader>

                <div v-for="(bankAccount, i) in bankAccounts" :key="i">

                    <v-list-tile avatar @click.prevent="showWithdrawForm(bankAccount)">

                        <v-list-tile-avatar>

                            <img :src="bankAccount.bank.logo_url" >

                        </v-list-tile-avatar>

                        <v-list-tile-content>

                            <v-list-tile-title v-html="bankAccount.bank_acc_name"></v-list-tile-title>

                            <v-list-tile-title v-html="bankAccount.bank_acc_no"></v-list-tile-title>

                            <v-list-tile-sub-title v-html="bankAccount.bank.name"></v-list-tile-sub-title>

                        </v-list-tile-content>

                    </v-list-tile>

                    <v-divider v-if="i+1 !== bankAccounts.length"></v-divider>

                </div>

            </v-list>

            <!--Dialog and Form-->
            <showDialog :status="dialog"
                :selectedBankAcc="data.selectedBank"
                :selectedProductId ="data.selectedProductId"
                :productsList="products"
                @DialogSave="save"  @DialogClose="close" />

            <!--Snackbar-->
            <snackbar :show="snackbar" :color="color" :text="message" :icon="'done_all'" :timeout="2000"/>

        </v-flex>

    </div>

</template>

<script>
import snackbar from "@/components/Reusable/Snackbar.vue";
import showDialog from "@/components/Withdrawal/Dialog.vue";
import Alert from "@/components/Reusable/Alert.vue";
import Api from "@/api";

export default {
    name: "BankList",
    data() {
        return {
            valid: true,
            data: {
                selectedBank: null,
                selectedProductId: null
            },
            bankAccounts: [],
            products: [],
            // Others variable
            dialog: false,
            alertType: "",
            alertMessage: "",
            visibility: false,
            progressbar: false,
            snackbar: false,
            message: "",
            color: ""
        }
    },
    components: {
        Alert,
        snackbar,
        showDialog
    },
    mounted() {
        // Check Game selected or not, not route to game list
        if(this.$route.params.product) {

            this.data.selectedProductId = this.$route.params.product.id;
        }

        this.getFormData();


    },
    watch: {
        'message': function(message) {
            let currentInstance = this;

            setTimeout(function() {

                currentInstance.snackbar = false;

                if (message == currentInstance.$t( 'deposit.submit_ticket_success' )) {
                    return currentInstance.$router.push({
                        name: 'home'
                    });
                }

            } , 1000);

        }
    },
    methods: {
        getImgUrl(img) {

            var images = require.context('@/assets/', false, /\.png$/);

            return images('./' + img + ".png");

        },
        save(response) {

            this.message = response.message;

            if (this.message == "Submit Ticket Successfully") {

                this.message = this.$t( 'deposit.submit_ticket_success' );

            }

            this.color = "green";

            this.dialog = response.dialog;

            this.snackbar = true;

        },
        close() {

            this.data.selectedBank = null;

            this.dialog = !this.dialog;

        },
        async getFormData() {

            this.progressbar = true;

            if(this.$store.getters.user_token != "") {

                await this.getBankAccounts();

                await this.getProducts();

                this.progressbar = false;

            } else {

                this.$router.push({name: 'login'})

            }

        },
        async getBankAccounts() {

            let res = await Api.getMemberInfo({
                access_token: this.$store.getters.user_token
            });

            if (res && 'success' in res && res.success === true) {

                this.bankAccounts = res.data.member_bank_acc;

            } else {

                this.visibility = true;

                this.alertMessage = res.message;

                this.alertType = "error";

                if(res.message == "token invalid") {

                    this.$store.dispatch('logout', res.data);

                    this.$router.push({name: 'login'})

                }

            }

        },
        async getProducts() {

            let res = await Api.getProductsMember({
                access_token: this.$store.getters.user_token
            });

            if (res && 'success' in res && res.success === true) {

                this.products = res.data;

                let currentInstance = this;

                this.products = this.products.map(function(product){

                    if(product.id == 1) {

                        product.logo = currentInstance.getImgUrl('wallet');
                    }

                    if(product.id != 1 && product.logo == '') {

                        product.logo = currentInstance.getImgUrl('coming-soon');

                    }

                    return product;

                });

            } else {

                this.visibility = true;

                this.alertMessage = res.message;

                this.alertType = "error";

                if(res.message == "token invalid") {

                    this.$store.dispatch('logout', res.data);

                    this.$router.push({name: 'login'})

                }

            }

        },
        showWithdrawForm(bankAcc) {

            this.data.selectedBank = bankAcc;

            this.dialog = !this.dialog;

        }

    }

}
</script>
